/**
 * Option sets are optional per language, but every language that is present
 * (or was present when the question loaded) must have exactly four options.
 * This prevents a partial update from being reported as a successful deletion.
 */
export const validateOptionCounts = ({
  englishOptions,
  hindiOptions,
  hadEnglishOptions = false,
  hadHindiOptions = false,
  maxOptions = 4,
}) => {
  const languages = [
    { name: "English", options: englishOptions, wasPresent: hadEnglishOptions },
    { name: "Hindi", options: hindiOptions, wasPresent: hadHindiOptions },
  ];

  for (const { name, options } of languages) {
    if (options.length > maxOptions) {
      return `A maximum of ${maxOptions} ${name} options is allowed.`;
    }
  }

  if (languages.every(({ options }) => options.length === 0)) {
    return `At least ${maxOptions} options are required to save.`;
  }

  for (const { name, options, wasPresent } of languages) {
    if ((wasPresent || options.length > 0) && options.length < maxOptions) {
      return `Exactly ${maxOptions} ${name} options are required before saving.`;
    }
  }

  return null;
};
